import { Link } from "react-router-dom";
import { articles, categories } from "@/mocks/gossipData";
import ArticleCard from "@/components/feature/ArticleCard";
import CategoryCard from "@/components/feature/CategoryCard";

export default function HomeExplore() {
  const picks = articles
    .filter((item) => item.isFeatured)
    .concat(articles.filter((item) => !item.isFeatured))
    .slice(0, 6);
  const latest = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 4);

  return (
    <>
      <section className="w-full bg-background-100 px-4 py-14 md:px-6 md:py-20" aria-label="主题分类">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-label uppercase tracking-widest text-secondary-700">
              Topics
            </span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">按主题找瓜</h2>
          </div>
          <p className="max-w-md text-sm text-foreground-600">
            六大主题分类，按你关心的话题快速定位，不用在信息流里漫无目的地刷。
          </p>
        </div>
        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <CategoryCard key={cat.slug} category={cat} />
          ))}
        </div>
      </section>

      <section className="w-full px-4 py-14 md:px-6 md:py-20" aria-label="编辑精选盘点">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-label uppercase tracking-widest text-primary-600">
              Editor&apos;s Picks
            </span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">精选盘点</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              由编辑从近期更新中挑出的合集，结构完整、看点集中。
            </p>
          </div>
          <Link
            to="/gossip"
            className="flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            浏览全部
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>
        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {picks.map((item) => (
            <ArticleCard key={item.id} article={item} />
          ))}
        </div>
      </section>

      <section className="w-full bg-background-100 px-4 py-14 md:px-6 md:py-20" aria-label="最新更新">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <span className="text-xs font-label uppercase tracking-widest text-accent-700">
              Latest
            </span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
              最近更新
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              每个工作日更新 3 到 5 篇盘点。想第一时间看到新合集，可以直接收藏本页。
            </p>
            <div className="mt-6 flex h-14 w-14 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
              <i className="ri-calendar-check-line text-2xl" aria-hidden="true" />
            </div>
          </div>
          <ul className="flex flex-col divide-y divide-background-300 lg:col-span-8">
            {latest.map((item) => (
              <li key={item.id}>
                <Link
                  to={`/gossip/${item.id}`}
                  className="group flex flex-col gap-2 py-5 transition-colors sm:flex-row sm:items-center sm:justify-between sm:gap-6 cursor-pointer"
                >
                  <span className="flex flex-col gap-1.5">
                    <span className="font-heading text-lg text-foreground-950 transition-colors group-hover:text-primary-600">
                      {item.title}
                    </span>
                    <span className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                      <span className="text-primary-600">{item.category}</span>
                      <span>{item.date}</span>
                      <span>编辑 {item.editor.replace("编辑 ", "")}</span>
                    </span>
                  </span>
                  <i
                    className="ri-arrow-right-up-line hidden shrink-0 text-xl text-foreground-300 transition-transform group-hover:-translate-y-0.5 group-hover:text-primary-500 sm:block"
                    aria-hidden="true"
                  />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}